import { render, staticRenderFns } from "./ResourceDetailLayout.vue?vue&type=template&id=29898f23&scoped=true&"
import script from "./ResourceDetailLayout.vue?vue&type=script&lang=js&"
export * from "./ResourceDetailLayout.vue?vue&type=script&lang=js&"
import style0 from "./ResourceDetailLayout.vue?vue&type=style&index=0&id=29898f23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29898f23",
  null
  
)

export default component.exports